import { Injectable } from '@angular/core';
import { Router, Route, CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ALNIdentityAuthService } from '../auth/aln-identity-auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private router: Router, private route: ActivatedRoute,
        private oidcSecurityService: OidcSecurityService, private authService: ALNIdentityAuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.loadFromLocal()) {
            return of(true);
        }

        return this.checkUser();
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.canActivate(route, state);
    }

    canLoad(state: Route): Observable<boolean> {
        return this.checkUser();
    }

    private saveRedirectUrl() {
        const pathName = window.location.pathname;
        const search = window.location.search;
        localStorage.setItem('redirect', `${pathName}${search}`);
    }

    private loadFromLocal(): boolean {
        const token = localStorage.getItem('token');
        if (token) {
            this.authService.setToken(token);
        }
        return !!token;
    }

    private checkUser(): Observable<boolean> {
        this.saveRedirectUrl();
        return this.oidcSecurityService.getIsAuthorized().pipe(first(),
            map((isAuthorized: boolean) => {
                if (!isAuthorized) {
                    this.oidcSecurityService.authorize();
                    return false;
                }
                return true;
            })
        );
    }
}
